import { useState } from "react";
import {
  useGetPlatformCreditInfo,
  useGetPlatformCreditTransactions,
} from "../../../../../hooks/api/queries/usePlatformCredit";
import { cleanObject } from "../../../../../helpers";

export const usePlatformCreditHistory = () => {
  const { queryParams, setQueryParams } = useState({
    page: 1,
    query: "",
    start_date: null,
    end_date: null,
  });
  const { data: platformTransactionsData, isLoading: isLoadingTnx } =
    useGetPlatformCreditTransactions({
      queries: "",
      queryParams: cleanObject({ queryParams }),
    });

  const { data: creditInfo, isLoading } = useGetPlatformCreditInfo();

  return {
    isLoading,
    isLoadingTnx,
    creditTransactions: platformTransactionsData?.data || [],
    metaDetails: platformTransactionsData?.meta || {},
    creditInfo,
    queryParams,
    filterByDate: (data) => {
      setQueryParams((prev) => ({
        ...prev,
        start_date: data?.startDate,
        end_date: data?.endDate,
      }));
    },
    filterBySearch: (val) => {
      setQueryParams((prev) => ({ ...prev, query: val }));
    },
    gotoPage: (val) => {
      setQueryParams((prev) => ({ ...prev, page: val }));
    },
  };
};
